const $j = jQuery.noConflict();

$j(() => {
  $j('.inlineLabel').focus(function fieldPlaceholderHandleFocus() {
    if ($j(this).attr('initial') === undefined) {
      $j(this).attr('initial', $j(this).val());
    }

    if ($j(this).val() === $j(this).attr('initial')) {
      $j(this).val('');
    }
  }).blur(function fieldPlaceholderBlurFocus() {
    if ($j(this).val() === '') {
      $j(this).val($j(this).attr('initial'));
    }
  });
});
